import { C4ListResponse } from '@domain/interface/c4-list-response';
import { createAction, props } from '@ngrx/store';
import { ProjectDTO, Owner, CustomerDTO } from 'cargo-chief-commons';

export const PROJECTS = {
	PROJECTS_LIST: {
		GET: createAction('[Projects] Get Projects', props<any>()),
		SUCCESS: createAction('[Projects] Get Projects success', props<C4ListResponse<ProjectDTO>>()),
		FAILURE: createAction(
			'[Projects] Get Projects failure',
			props<{ payload: { message: string } }>()
		),
	},
	USERS_LIST: {
		SET: createAction('[UsersList] Set Users List', props<{ usersList: Owner[] }>()),
	},
	SORT: {
		SET: createAction('[SORT] Projects Set sort', props<{ sort: any[] }>()),
	},
	FILTERS: {
		SET: createAction('[FILTERS] Projects Set filters', props<{ filters: any[] }>()),
	},
	EDIT_PROJECT: {
		OPEN_DIALOG: createAction(
			'[EDIT_PROJECT] Open dialog',
			props<{
				projects: any;
				action: string;
				title: string;
				cancelButtonText: string;
				confirmButtonText: string;
				usersList?: any;
				projectAction?: string;
				projectIds?: string[];
			}>()
		),
		UPDATE: createAction('[UPDATE_SUCCESS] Update Projects', props<{ payload: any }>()),
		UPDATE_SUCCESS: createAction(
			'[UPDATE_SUCCESS] Projects update successful',
			props<{ updatedProjects: Record<string, ProjectDTO> }>()
		),
		UPDATE_FAILED: createAction('[UPDATE_FAILED] Projects update failed', props<any>()),
		CLOSE: createAction('[CLOSE] Close update projects dialog', props<any>()),
		UPDATE_DUE_DATE: createAction(
			'[UPDATE_DUE_DATE] update projects due date',
			props<{ dueDate: Date; projectIds: string }>()
		),
		UPDATE_CUSTOMER: createAction(
			'[UPDATE_CUSTOMER] update projects customer',
			props<{ customerDTO: CustomerDTO; projectIds: string }>()
		),
		UPDATE_ASSIGNEE: createAction(
			'[UPDATE_ASSIGNEE] update projects assignee',
			props<{ assigneeId: number; projectIds: string }>()
		),
		UPDATE_OUT_OF_NETWORK: createAction(
			'[UPDATE_OUT_OF_NETWORK] update projects out of network',
			props<{ sendToOutOfNetworkCarriers: boolean; projectIds: string }>()
		),
	},
	ARCHIVE_PROJECTS: {
		ARCHIVE: createAction('[ARCHIVE] Archive selected projects', props<any>()),
		ARCHIVE_SUCCESS: createAction('[DELETE_SUCCESS] Projects deleted', props<any>()),
		ARCHIVE_FAILED: createAction('[DELETE_FAILED] Failed to archive projects', props<any>()),
	},
	UPLOAD_PROJECTS: {
		OPEN_DIALOG: createAction(
			'[UPLOAD_PROJECTS] Open dialog',
			props<{
				dataType: string;
				title: string;
				subtitle: string;
				secondStepTitle: string;
				thirdStepTitle: string;
			}>()
		),
		UPLOAD: createAction('[UPLOAD] Upload projects', props<any>()),
		SUCCESS: createAction('[SUCCESS] Projects upload successful', props<any>()),
		FAILURE: createAction('[FAILURE] Projects upload failed', props<any>()),
		CLOSE: createAction('[CLOSE] Close dialog', props<any>()),
	},
	CREATE_PROJECT: {
		OPEN_DIALOG: createAction('[Project CREATE_PROJECT] Open project dialog', props<any>()),
		SUCCESS: createAction('[Project SUCCESS] Project created successfully', props<any>()),
		FAILURE: createAction('[Project FAILURE] Failed to create project', props<any>()),
		CLOSE: createAction('[CLOSE] Close dialog', props<any>()),
	},

	ACTIVE_TAB: {
		SET: createAction('[ACTIVE_TAB] Projects Set ACTIVE_TAB', props<{ activeTab: string }>()),
	},

	CUSTOM_TAB: {
		GET: createAction('[CUSTOM TAB] Get Custom Tab', props<any>()),
		DELETE: createAction('[CUSTOM TAB] Delete Custom Tab', props<any>()),
		DELETE_SUCCESS: createAction('[CUSTOM TAB] Delete Custom Tab Success', props<any>()),
		SUCCESS: createAction('[CUSTOM TAB] Get Custom Tab Success', props<any>()),
		FAILURE: createAction(
			'[CUSTOM TAB]Get Custom Tab Failure',
			props<{ payload: { message: string } }>()
		),
	},
	TABS: {
		SET: createAction('[Projects TABS] Set tabs', props<{ allTabs: string[] }>()),
	},

	USERS_SORT_AND_FILTERS: {
		GET: createAction('[Projects TABS] Get saved users sorts and filters', props<any>()),
		SUCCESS: createAction('[Projects TABS] Get saved users sorts and filters Success', props<any>()),
		FAILURE: createAction('[Projects TABS] Get saved users sorts and filters Failure', props<any>()),
		SET: createAction('[Projects TABS] Set saved custom tabs and filters', props<any>()),
	},

	BA: {
		OPEN_DIALOG: createAction('[Projects] open BA form dialog', props<any>()),
		CLOSE_DIALOG: createAction('[Projects] close BA form dialog', props<any>()),
	},

	HISTORICAL_LOADS_COUNT: {
		GET: createAction('[Projects] Get historical loads count', props<any>()),
		SUCCESS: createAction('[Projects] Get historical loads success', props<any>()),
		FAILURE: createAction(
			'[Projects] Get historical loads failure',
			props<{ payload: { message: string } }>()
		),
	},
	ACTIVE_LOADS_COUNT: {
		GET: createAction('[Projects] Get active loads count', props<any>()),
		SUCCESS: createAction('[Projects] Get active loads success', props<any>()),
		FAILURE: createAction(
			'[Projects] Get active loads failure',
			props<{ payload: { message: string } }>()
		),
	},
};
